import { render, staticRenderFns } from "./possibility.vue?vue&type=template&id=c732e7c2&scoped=true&"
import script from "./possibility.vue?vue&type=script&lang=js&"
export * from "./possibility.vue?vue&type=script&lang=js&"
import style0 from "./possibility.vue?vue&type=style&index=0&id=c732e7c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c732e7c2",
  null
  
)

export default component.exports